// "Ask your manufacturer" flag strip shown under LCA wizard steps. Flagging a
// section (or a single field of a single part) drops it into the calculator's
// request basket; the floating pill opens RequestModal prefilled with them.

import React from 'react';

const SECTION_LABELS = {
  weight: 'Product weight',
  country_of_origin: 'Country of origin',
  parts: 'All parts & materials',
  packaging: 'Packaging',
  manufacturing: 'Manufacturing & energy',
  transport: 'Transport',
};

const PART_FIELD_OPTIONS = [
  { field: 'process_name', label: 'Process' },
  { field: 'material_category', label: 'Material' },
  { field: 'material_subcategory', label: 'Material type' },
  { field: 'material_quality', label: 'Quality' },
  { field: 'weight_grams', label: 'Weight' },
];

export function flagIdentity(f) {
  return [f.key, f.part_index ?? '', f.field ?? ''].join('|');
}

export default function AskManufacturerBar({ options = [], parts = null, flags = [], onToggle }) {
  const has = (f) => flags.some((x) => flagIdentity(x) === flagIdentity(f));
  const wholePartsFlagged = has({ key: 'parts' });

  return (
    <div style={{ marginTop: 16, padding: '10px 14px', background: '#f8fafc', border: '1px dashed #cbd5e1', borderRadius: 10 }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: '#64748b', marginBottom: 6 }}>
        🏭 Don't know something here? Flag it to ask your manufacturer.
      </div>
      <div className="d-flex flex-wrap gap-1 align-items-center">
        {options.map((key) => (
          <FlagChip key={key} active={has({ key })} onClick={() => onToggle({ key })}>
            {SECTION_LABELS[key] || key}
          </FlagChip>
        ))}
      </div>
      {Array.isArray(parts) && parts.length > 0 && !wholePartsFlagged && (
        <div style={{ marginTop: 8 }}>
          {parts.map((part, i) => (
            <div key={i} className="d-flex align-items-center flex-wrap gap-1" style={{ marginBottom: 4 }}>
              <span style={{ fontSize: 12, color: '#475569', minWidth: 120 }}>
                {part.name || part.material_subcategory || part.material_category || `Part ${i + 1}`}
                {part.weight_grams ? ` · ${part.weight_grams}g` : ''}
              </span>
              {PART_FIELD_OPTIONS.map((f) => (
                <FlagChip
                  key={f.field}
                  small
                  active={has({ key: 'part_field', part_index: i, field: f.field })}
                  onClick={() => onToggle({ key: 'part_field', part_index: i, field: f.field })}
                >
                  {f.label}
                </FlagChip>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function FlagChip({ children, active, onClick, small }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        background: active ? '#111827' : '#fff',
        color: active ? '#fff' : '#475569',
        border: `1px solid ${active ? '#111827' : '#e2e8f0'}`,
        borderRadius: 99,
        padding: small ? '2px 9px' : '3px 12px',
        fontSize: small ? 11 : 12,
        fontWeight: 500,
        whiteSpace: 'nowrap',
      }}
    >
      {active ? '✓ ' : '⚑ '}{children}
    </button>
  );
}
